"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Root = styled_components_1.default.img.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isRound', 'isLoading', 'ratio', 'fit'].includes(prop);
  }
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", "\n  ", "\n"], ["\n  ", ";\n  ", ";\n  ", "\n  ", "\n"])), function (_a) {
  var isRound = _a.isRound;
  return isRound && 'border-radius: 50%;';
}, function (_a) {
  var isLoading = _a.isLoading;
  return isLoading && 'filter: blur(1rem);';
}, function (_a) {
  var ratio = _a.ratio;
  return ratio && "aspect-ratio: ".concat(ratio, ";");
}, function (_a) {
  var fit = _a.fit;
  return fit && "object-fit: ".concat(fit, ";");
});
var templateObject_1;